import React, { useMemo } from "react";
import { Hash } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";

interface BookingQuantitySelectProps {
  value: number;
  onChange: (value: number) => void;
  disabled: boolean;
  label: string;
  limit: number | undefined;
}

const BookingQuantitySelect: React.FC<BookingQuantitySelectProps> = React.memo(
  (props) => {
    const availableQuantities = useMemo(() => {
      const max = props.limit != null ? props.limit : 1;
      if (max < 1) return [];
      return Array.from({ length: max }, (_, i) => i + 1);
    }, [props.limit]);

    const handleValueChange = (value: string) => {
      props.onChange(Number(value));
    };

    const hasValue = props.value && props.value !== 0;

    return (
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-slate-900">
          {props.label}
          <span className="text-red-500 ml-1">*</span>
        </label>
        <Select
          value={props.value?.toString() || "0"}
          onValueChange={handleValueChange}
          disabled={props.disabled || availableQuantities.length === 0}
        >
          <SelectTrigger
            className="w-full h-14 text-base border rounded-xl bg-white text-slate-900 border-black"
            aria-label={props.label}
          >
            <div className="flex items-center gap-2 w-full">
              <Hash className="h-5 w-5 text-slate-600 shrink-0" />
              <SelectValue placeholder={props.label}>
                {hasValue ? props.value : props.label}
              </SelectValue>
            </div>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="0">
              <span className="text-slate-500">{props.label}</span>
            </SelectItem>
            {availableQuantities.map((quantity) => (
              <SelectItem key={quantity} value={quantity.toString()}>
                {quantity}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
);

export default BookingQuantitySelect;
